import { Role } from "@libs/interfaces/layouts";

export const getModeratorRoles = (): Role[] => {
    return [ "administrator", "SuperAdmin", "Track_moderator", "School_guardian"]
}